function registerElementsToObserver (observer, observableElements) {
  for (const element of observableElements) {
    observer.observe(element)
  }
}

function scanPageForElements (dataAttr) {
  const elements = document.querySelectorAll(`[${dataAttr}]`)
  return Array.from(elements)
}

function getNewObserver (ctx) {
  const observerCallback = (entries, observer) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        ctx.data.observedElements.push(entry.target)
        observer.unobserve(entry.target)
      }
    }
  }
  return new IntersectionObserver(observerCallback, ctx.observerOptions)
}

function tick (ctx) {
  if (ctx.data.observedElements.length <= 0) {
    return
  }
  for (const element of ctx.data.observedElements) {
    if (ctx.data.pushedElements.includes(element)) {
      const index = ctx.data.observedElements.indexOf(element)
      ctx.data.observedElements.splice(index, 1)
    }
  }
  postViewMetrics(ctx.data.observedElements, ctx.data.dataAttr, 'impressions').then(() => {
    ctx.data.pushedElements = ctx.data.pushedElements.concat(ctx.data.observedElements)
    ctx.data.observedElements = []
  })
}

function registerHitTrackingEvent (ctx) {
  for (const element of ctx.data.trackedElements) {
    element.addEventListener('click', () => {
      postViewMetrics([element], ctx.data.dataAttr, 'hits').then()
    }, {
      once: true,
      passive: true,
      capture: true
    })
    element.addEventListener('touchstart', () => {
      postViewMetrics([element], ctx.data.dataAttr, 'hits').then()
    }, {
      once: true,
      passive: true,
      capture: true
    })
  }
}

async function postViewMetrics (elements, dataAttr, metricType) {
  const data = {
    impressions: [],
    hits: []
  }
  for (const element of elements) {
    const ovm = JSON.parse(atob(element.getAttribute(dataAttr)))
    data[metricType].push(ovm)
  }
  const url = '/view_metrics/api/record'
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }
  await fetch(url, options)
}

export default class ObservableViewMetrics {
  constructor (options = {}) {
    this.data = {
      observer: null,
      dataAttr: 'data-ovm',
      trackedElements: [],
      observableElements: [],
      observedElements: [],
      pushedElements: [],
      observerOptions: {
        root: null,
        rootMargin: '0px',
        threshold: 0.25
      },
      tickLoopUpdateInterval: 1000
    }

    this.data.observer = getNewObserver(this)
    this.data.trackedElements = scanPageForElements(this.data.dataAttr)
    this.data.observableElements = this.data.trackedElements.slice(0)
    registerElementsToObserver(this.data.observer, this.data.observableElements)
    registerHitTrackingEvent(this)

    setInterval(() => {
      tick(this)
    }, this.data.tickLoopUpdateInterval)
  }
}
